<ng-container *ngIf="paymentResponseMessage">
  <div class="page-title">
    Detalhes do código de erro - {{ paymentResponseMessage.code }} -
    {{ gateway?.gatewayName }}
  </div>
  <div class="details payment-response-message-detail">
    <div class="card">
      <p-tabView
        [activeIndex]="selectedTab"
        (activeIndexChange)="goToResponseMessage($event)"
        *ngIf="selectedTab !== undefined"
      >
        <p-tabPanel header="Informações gerais">
          <ng-template pTemplate="content">
            <app-payment-response-message-form
              [paymentResponseMessage]="paymentResponseMessage"
              (buttonAction)="paymentResponseMessage = $event"
            />
          </ng-template>
        </p-tabPanel>
        <p-tabPanel
          header="Pagamentos {{
            totalPayments !== undefined
              ? '(' + (totalPayments | number: '1.0-0') + ')'
              : ''
          }}"
        >
          <ng-template pTemplate="content">
            <app-table
              [cols]="paymentCols"
              [service]="paymentService"
              [findPage]="findPaymentPage"
              [addButton]="false"
              modelName="pagamentos"
              sortField="creditCardPaymentId"
              [dropdownFilters]="dropdownFilters"
              [fixedFilters]="[
                {
                  condition: 'equals',
                  field: 'paymentResponseMessageId',
                  fieldType: 'number',
                  value: this.paymentResponseMessage?.paymentResponseMessageId
                }
              ]"
              [sortOrder]="1"
              *ngIf="dropdownFilters"
              [multiSelectFilter]="true"
              (tableLoaded)="setTotal()"
            />
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</ng-container>
<div class="payment-response-message-form" *ngIf="!paymentResponseMessage">
  <div class="page-title">Novo código de erro</div>
  <app-payment-response-message-form
    [paymentResponseMessage]="null"
    (buttonAction)="goToResponseMessage($event)"
  />
</div>
<p-toast />
<p-confirmPopup />
